import React from 'react';
import { Badge, CatalogImage } from 'components';

import { StyledP } from '../typography';
import { trackAssetClicked } from 'analytics/itly/hooks';
import { CATALOG_IMAGE_RESPONSIVE_SIZES } from 'constants/images';
import { ProductBadge, ProductBlockWrapper, ProductDetailsWrapper } from '../styled';
import { ProductType } from 'features/pdp/types/event';
import { getGatsbySiteUrl } from 'helpers/env';
import { getBookSizePricing } from 'features/pdp';
import { renderStrikethroughPricing } from 'helpers/strikethroughPricing';

interface RelatedProductBlockProps {
  product: ProductType
  size: string;
}

/**
 * This component is a duplicate of RelatedProducts/ProductBlock used for 
 * EN-10161 Explore Similar Products by Size A/B test
 */
export const ProductBlock = ({ product, size }: RelatedProductBlockProps): JSX.Element => {
  const { sku, name, badges, image, canonicalUrl, valueProposition, metaDescription } = product;
  const href = `${getGatsbySiteUrl()}/${canonicalUrl}/${size}`;
  const alt = `${sku}_image`;
 
  const price = (product.lowestPrice || product.price) + getBookSizePricing(product, size);

  // In case of multiple badges, just grab the first badge in the list.
  const badge = badges && badges.length > 0 && badges[0];
  return (
    <ProductBlockWrapper className="product-block-wrapper">
      {badge && (
        <ProductBadge>
          <Badge>{badge}</Badge>
        </ProductBadge>
      )}
      <a onClick={() => trackAssetClicked(name || alt, 'ProductBlockRelatedBySize', href)} href={href}>
        <CatalogImage src={image} alt={alt} widths={CATALOG_IMAGE_RESPONSIVE_SIZES} />
      </a>
      <ProductDetailsWrapper>
        <a onClick={() => trackAssetClicked(name || alt, 'ProductBlockRelatedBySize', href)} href={href} style={{ width: '100%' }}>
          <StyledP className="product-block-label">{name}</StyledP>
        </a>
        <StyledP className="product-block-price-label">
          From {renderStrikethroughPricing(price, product)}
        </StyledP>
        <StyledP className="product-block-description">
          {valueProposition || metaDescription}
        </StyledP>
      </ProductDetailsWrapper>
    </ProductBlockWrapper>
  );
};
